// extracted by mini-css-extract-plugin
var _1 = "DescriptionEdit_editor__4POlp";
export { _1 as "editor" }
